import * as React from "react"

function SvgFacebook(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 15 28"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.851 8.365a.558.558 0 00-.418-.198h-4.261V6.522c0-.327.068-.7.576-.7h3.391a.488.488 0 00.396-.175.594.594 0 00.158-.397V.583A.575.575 0 0014.128 0H9.234C3.809 0 3.39 4.783 3.39 6.242v1.925H.565A.575.575 0 000 8.75v4.667c0 .322.253.583.565.583h2.826v13.417c0 .322.253.583.565.583h5.65a.575.575 0 00.566-.583V14h3.786a.573.573 0 00.565-.525l.475-4.667a.592.592 0 00-.147-.443z"
      />
    </svg>
  )
}

export default SvgFacebook
